import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import FastQuotingDoorVersionsDataService from "./services/fastquotingdoorversions.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import FastQuoteDoorVersionsList from './FastQuoteDoorVersionsList';
import { useParams } from "react-router-dom";
import MessageBox from './MessageBox';
import { doorstyles, producttypes } from './AuxiliaryFunctions';


var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const WrapperDoorFastQuoteVersions = (props) => {
  const params = useParams();
  return <DoorFastQuoteVersions {...props} id={params.id}/>;
};


class DoorFastQuoteVersions extends Component {

  constructor(props) {
    super(props);
    this.onChangeDoorFastQuoteVersionsFilterVersionNum = this.onChangeDoorFastQuoteVersionsFilterVersionNum.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);
    this.duplicateVersion = this.duplicateVersion.bind(this);

    this.state = {
      listOfDoorFastQuotesVersions: null,
      DoorFastQuoteVersionsFilterVersionNum: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.props.id,this.state.DoorFastQuoteVersionsFilterVersionNum,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.props.id,this.state.DoorFastQuoteVersionsFilterVersionNum,e.target.value,this.state.SortType);
  }

  onChangeDoorFastQuoteVersionsFilterVersionNum(e) {
    console.log(e.target.value);
    this.setState({
        DoorFastQuoteVersionsFilterVersionNum: e.target.value
    });
    this.performSearch(this.props.id,e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.props.id,this.state.DoorFastQuoteVersionsFilterVersionNum, this.state.SortField,this.state.SortType);  
  }

  performSearch = (id,descr,sortfield,sorttype) => {
    FastQuotingDoorVersionsDataService.getfastquotingdoorversionsByDescr(id,descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfFastQuotingDoorVersions: response.data
        });
        console.log(this.state.listOfFastQuotingDoorVersions);
      })
      .catch(e => {
        console.log(e);
      });
  };

  duplicateVersion = (fastquotingdoorId, id) => { 
    // fastquotingdoorId is the id of the fastquotingdoor
    // id is the field value of the record to duplicate in the fastquotingdoorversions table
    FastQuotingDoorVersionsDataService.getAll(fastquotingdoorId) 
    .then(firstresponse => {
      console.log(firstresponse);
      const versionnumber = firstresponse.data.length+1;
      console.log(versionnumber);
      FastQuotingDoorVersionsDataService.get(id)
        .then(secondresponse => {
        const rowtoduplicate = secondresponse.data;
        rowtoduplicate.userId = this.props.user.id;
        rowtoduplicate.versionnumber = versionnumber;
        rowtoduplicate.doors = rowtoduplicate.versiondoordetail;
        delete rowtoduplicate.versiondoordetail;

        const updatedDoors = rowtoduplicate.doors.map(door => {
            const matchedProductType = producttypes.find(pt => pt.id === door.producttype);
            const matchedDoorStyle = doorstyles.find(ds => ds.id === door.doorstyle);
            return {
                ...door,
                producttype: matchedProductType || door.producttype, // fallback to original if no match found
                doorstyle: matchedDoorStyle || door.doorstyle // fallback to original if no match found
            };
        });

        rowtoduplicate.doors = updatedDoors;
        console.log(rowtoduplicate);        
        
        FastQuotingDoorVersionsDataService.create(rowtoduplicate)
        .then(thirdresponse => {
          //console.log(thirdresponse);
          window.location.reload();
        })
        .catch(error => {
          console.log(error);
        })
        

      })
      .catch(err => {
        console.log(err);
      })
    })
    .catch(error => {
      console.log(error);
    })
  }

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <Container style={{width:"80%"}}>
        <Container>
          <Row className='mb-2 d-flex'>
            <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
            <hr/>
            <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Door Fast Quote Versions</h4>
            <Col lg={true}>
              <FormLabel className='mb-2'>Filter by Version Number:</FormLabel>       
              <FormControl type="text" name="filterbyquoteversion" id="filterbyquoteversion" onChange={this.onChangeDoorFastQuoteVersionsFilterVersionNum}></FormControl>
            </Col>
            <Col lg={true}>
              <FormLabel className='mb-2'>Sort By:</FormLabel>       
                <FormControl as='select' onChange={this.onChangeSortField}>
                  <option value="id">Quote Version</option>
                  <option value="createdAt">Created At</option>
                  <option value="totalquoteversion">Total Amount</option>
                </FormControl>
            </Col>
            
            <Col sm={true}>
              <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
              <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
            </Col>          
          </Row>
          <Link to="/new-door-fast-quote" className="mr-2 btn btn-primary">New Door Fast Quote</Link>            
          <Button className="m-2 btn btn-primary">Export</Button>        
          <Row>
            <FastQuoteDoorVersionsList 
              mode={0} 
              listOfFastQuotingDoorVersions = {this.state.listOfFastQuotingDoorVersions} 
              duplicateVersion= {this.duplicateVersion}
            />      
          </Row>
        </Container>
      </Container>
      </>
    )
  }
}

export default WrapperDoorFastQuoteVersions;